/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PortList } from './PortList';
import {
    PortListFromJSON,
    PortListFromJSONTyped,
    PortListToJSON,
} from './PortList';

/**
 * 
 * @export
 * @interface PortListGet200Response
 */
export interface PortListGet200Response {
    /**
     * 
     * @type {Array<PortList>}
     * @memberof PortListGet200Response
     */
    records?: Array<PortList>;
}

/**
 * Check if a given object implements the PortListGet200Response interface.
 */
export function instanceOfPortListGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PortListGet200ResponseFromJSON(json: any): PortListGet200Response {
    return PortListGet200ResponseFromJSONTyped(json, false);
}

export function PortListGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortListGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(PortListFromJSON)),
    };
}

export function PortListGet200ResponseToJSON(value?: PortListGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(PortListToJSON)),
    };
}

